module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-result "
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading dash-bg-color-skin-light-10"
  }, [_c('div', {
    staticClass: "col-xs-2 pull-left align-left head-left"
  }, [_c('div', {
    staticClass: "rec"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-chevron-left back-mb cursor-pointer",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.toggle('list')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 pull-left align-center head-center"
  }, [_c('div', {
    staticClass: "contactlabel"
  }, [_vm._v(" " + _vm._s(_vm.labels[_vm.nowLang].contactLabel) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 pull-right align-right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pcDisp),
      expression: "pcDisp"
    }],
    staticClass: "back-for-pc"
  }, [_c('i', {
    staticClass: "fa fa-chevron-left cursor-pointer",
    on: {
      "click": function($event) {
        _vm.toggle('list')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-ms-12 col-sm-12 col-md-12"
  }, [(_vm.contact.image_path !== '') ? [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": _vm.baseURL + _vm.contact.image_path + '?' + (Math.random() * 100)
    }
  })] : [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": require("static/images/employee/no_image.png")
    }
  })], _vm._v(" "), _c('contact-fav', {
    attrs: {
      "postContactFavorite": _vm.postContactFavorite,
      "codempid": _vm.contact.codempid
    },
    model: {
      value: (_vm.contact.codempfav),
      callback: function($$v) {
        _vm.$set(_vm.contact, "codempfav", $$v)
      },
      expression: "contact.codempfav"
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-ms-12 col-sm-12 col-md-12 center"
  }, [_c('label', {
    staticClass: "name dash-color-skin"
  }, [_vm._v(_vm._s(_vm.contact.desc_codempid))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-ms-12 col-sm-12 col-md-12 center"
  }, [_c('label', {
    staticClass: "company"
  }, [_vm._v(_vm._s(_vm.contact.desc_codcomp))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-ms-12 col-sm-12 col-md-12 center"
  }, [_c('label', {
    staticClass: "position"
  }, [_vm._v(_vm._s(_vm.contact.desc_codpos))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-ms-12 col-sm-12 col-md-12 centeri box-call"
  }, [_c('span', {
    staticClass: "fa-stack fa-lg set-position-icon"
  }, [(Object(_vm.contact.numtelec).length == 1) ? _c('a', {
    staticClass: "disabled fa fa-circle-thin fa-stack-2x icon_dis dash-color-skin"
  }) : _vm._e(), _vm._v(" "), (Object(_vm.contact.numtelec).length == 1) ? _c('a', {
    staticClass: "disabled fa fa-phone fa-stack-1x fa-inverse phone",
    attrs: {
      "href": 'tel:' + _vm.contact.numtelec
    }
  }, [_c('label', {
    staticClass: "font_icon_dis"
  }, [_vm._v(_vm._s(_vm.labels[_vm.nowLang].call))])]) : _vm._e(), _vm._v(" "), (Object(_vm.contact.numtelec).length > 1) ? _c('a', {
    staticClass: "fa fa-circle fa-stack-2x icon dash-color-skin"
  }) : _vm._e(), _vm._v(" "), (Object(_vm.contact.numtelec).length > 1) ? _c('a', {
    staticClass: "fa fa-phone fa-stack-1x fa-inverse phone",
    attrs: {
      "href": 'tel:' + _vm.contact.numtelec
    }
  }, [_c('label', {
    staticClass: "font_icon"
  }, [_vm._v(_vm._s(_vm.labels[_vm.nowLang].call))])]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "fa-stack fa-lg set-position-icon"
  }, [(Object(_vm.contact.email).length == 1) ? _c('a', {
    staticClass: "disabled fa fa-circle-thin fa-stack-2x icon_dis dash-color-skin"
  }) : _vm._e(), _vm._v(" "), (Object(_vm.contact.email).length == 1) ? _c('a', {
    staticClass: "disabled fa fa-envelope fa-stack-1x fa-inverse ",
    attrs: {
      "href": 'mailto:' + _vm.contact.email
    }
  }, [_c('label', {
    staticClass: "font_icon_dis"
  }, [_vm._v(_vm._s(_vm.labels[_vm.nowLang].mail))])]) : _vm._e(), _vm._v(" "), (Object(_vm.contact.email).length > 1) ? _c('a', {
    staticClass: "fa fa-circle fa-stack-2x icon dash-color-skin"
  }) : _vm._e(), _vm._v(" "), (Object(_vm.contact.email).length > 1) ? _c('a', {
    staticClass: "fa fa-envelope fa-stack-1x fa-inverse ",
    attrs: {
      "href": 'mailto:' + _vm.contact.email
    }
  }, [_c('label', {
    staticClass: "font_icon"
  }, [_vm._v(_vm._s(_vm.labels[_vm.nowLang].mail))])]) : _vm._e()])]), _vm._v(" "), (Object(_vm.contact.numtelof).length == 1) ? _c('div', {
    staticClass: "row phone_display"
  }) : _vm._e(), _vm._v(" "), (Object(_vm.contact.numtelof).length > 1) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-10"
  }, [_c('label', {
    staticClass: "position"
  }, [_vm._v(_vm._s(_vm.labels[_vm.nowLang].work))]), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "detail"
  }, [_vm._v(_vm._s(_vm.contact.numtelof))])])]) : _vm._e(), _vm._v(" "), (Object(_vm.contact.numtelec).length == 1) ? _c('div', {
    staticClass: "row phone_display"
  }) : _vm._e(), _vm._v(" "), (Object(_vm.contact.numtelec).length > 1) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-10"
  }, [_c('label', {
    staticClass: "position"
  }, [_vm._v(_vm._s(_vm.labels[_vm.nowLang].mobile))]), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "detail"
  }, [_vm._v(_vm._s(_vm.contact.numtelec))])])]) : _vm._e(), _vm._v(" "), (Object(_vm.contact.email).length == 1) ? _c('div', {
    staticClass: "row phone_display"
  }) : _vm._e(), _vm._v(" "), (Object(_vm.contact.email).length > 1) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-10"
  }, [_c('label', {
    staticClass: "position"
  }, [_vm._v(_vm._s(_vm.labels[_vm.nowLang].email))]), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "detail"
  }, [_vm._v(_vm._s(_vm.contact.email))])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-2"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-phone-alt icon2"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-2"
  }, [_c('span', {
    staticClass: "fa fa-mobile icon3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-2"
  }, [_c('span', {
    staticClass: "fa fa-envelope icon2"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2540f98a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contact/contactDetail.vue
// module id = 3634
// module chunks = 1